import React, { useEffect, useRef, useState } from "react";
import { modalEventListenerAllowScroll } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import { toast } from "react-toastify";

const ShareRemarksModal = ({
  id,
  disableLoan,
  disableTitle,
  disbursement_id,
  lead_id,
  closeShareRemarksModal,
  fetchRemarksData,
}) => {
  const initialState = { shareWithLoanBox: false, shareWithTitleBox: false };
  const [state, setState] = useState(initialState);
  const ref = useRef();
  useEffect(() => {
    return modalEventListenerAllowScroll(ref, closeShareRemarksModal);
  }, [closeShareRemarksModal]);

  const handleCheckboxChange = (e, shareWith) => {
    const { checked } = e.target;
    setState({ ...state, [shareWith]: checked });
  };

  const shareRemark = async () => {
    toast.dismiss();
    if (!state.shareWithLoanBox && !state.shareWithTitleBox)
      return toast.error("Select checkbox you want to share remark with", {
        theme: "colored",
      });
    try {
      const shared_with = [];
      if (state.shareWithLoanBox) shared_with.push(1);
      if (state.shareWithTitleBox) shared_with.push(3);
      const response = await axios_instance({
        url: "/dts/shareRemark",
        method: "POST",
        data: {
          disbursement_id,
          lead_id,
          source_id: 2,
          shared_with,
          shared_remark_id: id,
        },
      });

      if (response.status === 200) {
        fetchRemarksData();
      }
    } catch (error) {
    } finally {
      closeShareRemarksModal();
    }
  };

  return (
    <ul
      className="dropdown-menu pull-right share-remark-dd"
      aria-labelledby={`dropdownMenu_${id}`}
      ref={ref}
    >
      <h4>
        <label className="label_text">Share remark with?</label>
      </h4>
      <li className="flt-lft">
        <div className="details_text sharing_cb">
          <input
            disabled={disableLoan || false}
            value="1"
            name="shared_to"
            id={`group1_${id}`}
            type="checkbox"
            onChange={(e) => handleCheckboxChange(e, "shareWithLoanBox")}
          />
          <label htmlFor={`group1_${id}`}>LoanBox</label>
        </div>
      </li>
      <li className="flt-lft">
        <div className="details_text sharing_cb">
          <input
            disabled={disableTitle || false}
            value="3"
            name="shared_to"
            id={`group3_${id}`}
            type="checkbox"
            onChange={(e) => handleCheckboxChange(e, "shareWithTitleBox")}
          />
          <label htmlFor={`group3_${id}`}>TitleBox</label>
        </div>
      </li>
      <li>
        <button
          className="btn btn-success pull-right share-remark-btn"
          onClick={shareRemark}
        >
          Share
        </button>
      </li>
    </ul>
  );
};

export default ShareRemarksModal;
